export const ADD_PARTNER_RESOURCES = gql`
    mutation addPartnerResource($input: AddResourceInput!) {
        addPartnerResource(input: $input) {
            createdAt
            resourceUrl
        }
    }
`;

export const ADD_PARTNER_RESOURCES_SECTION = gql`
    mutation addPartnerResourceSection($input: AddResourceSectionInput!) {
        addPartnerResourceSection(input: $input) {
            id
            name
            status
            pinnedAt
            createdAt
            createdByName
        }
    }
`;
